import dayjs from "dayjs";

function isSunday(date: string) {
    return dayjs(date).day() === 0;
}

export type DayStrings = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday";

export const openingHours: Record<DayStrings, string> = {
    monday: "10:00-18:00",
    tuesday: "10:00-17:00",
    wednesday: "10:00-17:00",
    thursday: "10:00-18:00",
    friday: "10:00-15:00",
    saturday: "STÄNGT (jun,jul & aug)",
};

export function generateClosedDates(customClosedDates: string[] = []) {
    const closedDates = [
        "2021-07-17",
        "2021-07-24",
        "2021-07-31",
        "2021-08-07",
        "2021-08-14",
        "2021-08-21",
        "2021-08-28",
        "2022-01-06",
        "2022-01-07",
        "2022-05-26",
        "2022-05-27",
        "2023-01-06",
        "2023-04-07",
        "2023-04-10",
        "2023-07-28",
        "2023-07-29",
        "2023-12-30",
        "2024-01-06",
        "2024-03-29",
        "2024-03-30",
        "2024-04-01",
        "2024-04-27",
        "2024-06-07",
        "2024-07-29",
        "2024-07-30",
        "2024-07-31",
        "2024-08-01",
        "2024-08-02",
        "2024-11-02",
        "2024-12-23",
        "2025-04-18",
        "2025-04-19",
        "2025-04-21",
        ...customClosedDates,
    ];

    const recurringClosedDates = [
        `${new Date().getFullYear()}-01-01`, // New Year's Day
        `${new Date().getFullYear()}-01-06`, // 13-dag jul
        `${new Date().getFullYear()}-05-01`,
        `${new Date().getFullYear()}-06-06`, // Nationaldagen
        `${new Date().getFullYear()}-12-24`, // Christmas Eve
        `${new Date().getFullYear()}-12-25`, // Christmas Day
        `${new Date().getFullYear()}-12-26`, // Annandag jul
        `${new Date().getFullYear()}-12-31`, // New Year's Eve
    ];

    // Only add recurring dates if they are not already in the closedDates array
    // and if they're not on a Sunday
    recurringClosedDates.forEach((date) => {
        if (!closedDates.includes(date)) {
            closedDates.push(date);
        }
    });
    return closedDates.filter((d) => !isSunday(d));
}

const closedDates = generateClosedDates();

export { closedDates };
